import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { InputTextarea } from 'primereact/inputtextarea';
import ImageUploadField from './ImageUploadField';

/**
 * Formulario de la sección principal
 */
const SeccionPrincipal = ({ formData, setFormData, opcionesClientes }) => {
    console.log("opcionesClientes",opcionesClientes);
    
    return (
        <div style={{ padding: '1rem' }}>
            <div style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Checkbox
                    inputId="activoGeneral"
                    checked={formData.activo}
                    onChange={(e) => setFormData({ ...formData, activo: e.checked })}
                />
                <label htmlFor="activoGeneral" style={{ fontWeight: 'bold' }}>
                    Landing Activa
                </label>
            </div>

            <div className="field" style={{ marginBottom: '1.5rem' }}>
                <label htmlFor="nombre">Título (Nombre) *</label>
                <InputText
                    id="nombre"
                    value={formData.nombre}
                    onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                    style={{ width: '100%', marginTop: '0.5rem' }}
                />
            </div>

            <div className="field" style={{ marginBottom: '1.5rem' }}>
                <label htmlFor="cliente">Cliente *</label>
                <Dropdown
                    id="cliente"
                    value={formData.cliente}
                    options={opcionesClientes || []}
                    onChange={(e) => setFormData({ ...formData, cliente: e.value })}
                    optionLabel="name"
                    placeholder="Seleccione un cliente"
                    style={{ width: '100%', marginTop: '0.5rem' }}
                    disabled={!opcionesClientes || opcionesClientes.length === 0}
                    emptyMessage="No hay clientes disponibles"
                />
            </div>

            <div className="field" style={{ marginBottom: '1.5rem' }}>
                <label htmlFor="contenido">Contenido</label>
                <InputTextarea
                    id="contenido"
                    value={formData.contenido}
                    onChange={(e) => setFormData({ ...formData, contenido: e.target.value })}
                    rows={4}
                    style={{ width: '100%', marginTop: '0.5rem' }}
                />
            </div>

            <ImageUploadField
                label="Imagen Principal"
                value={formData.imagen}
                onChange={(file) => setFormData({ ...formData, imagen: file })}
                showPreview={true}
            />
        </div>
    );
};

export default SeccionPrincipal;
